// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#outing-detail[data-v-849d1cde]{max-width:840px;margin-left:auto;margin-right:auto}#outing-detail .detail-content[data-v-849d1cde]{max-width:600px;min-width:600px}#outing-detail .cancel-btn[data-v-849d1cde],#outing-detail .edit-btn[data-v-849d1cde]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
